exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n.cancelled-result {\n  text-align: left;\n}\n\n.result-tooltip {\n  white-space: normal;\n  text-align: left;\n}\n\ndata-revision-indicator {\n  position: relative;\n  top: 2px;\n}\n\ndiv[result-content] {\n  cursor: pointer;\n}\n\n", ""]);

// exports
